<div fxLayout="column" *ngIf="hasLoaded">

    <mat-card>
        <mat-card-content>
            <div fxLayoutAlign="center center" fxLayout="row" fxLayoutGap="15px" class="p-10 text-danger">
                <mat-icon>warning</mat-icon>
                <span>DO NOT create or edit a product categorizations without discussing and understanding the ramifications of the change.</span>
                <mat-icon>warning</mat-icon>
            </div>
        </mat-card-content>
    </mat-card>

    <mat-card>
        <mat-card-header>
            <mat-card-title>Product Classifications</mat-card-title>
        </mat-card-header>
        <mat-card-content>
            <div>
                <mat-form-field>

                    <input matInput type="text" placeholder="Select Product Classification" [formControl]="classificationControl" [matAutocomplete]="classificationAuto">
                    <button mat-button *ngIf="selectedProductClassification && !updateProductClassificationMode && !addProductClassificationMode" matSuffix mat-icon-button aria-label="Clear" (click)="clearClassificationSelection()">
                        <mat-icon>close</mat-icon>
                    </button>
                    <mat-autocomplete #classificationAuto="matAutocomplete" [displayWith]="displayClassificationName" (optionSelected)="onClassificationSelected($event.option.value)">
                        <mat-option *ngFor="let item of filteredClassifications | async" [value]="item">
                            <span [innerHtml]="displayClassificationName(item) | encodeHtml | highlight: classificationControl.value"></span>
                        </mat-option>
                    </mat-autocomplete>
                </mat-form-field>

                <mat-card *ngIf="!selectedProductClassification" class="contrast">
                    <mat-card-content fxLayout="column" fxLayoutAlign="space-around center" fxLayoutGap="15px">
                        <div>Select a Product Classification</div>
                        <div><b>OR</b></div>
                        <button type="button" mat-flat-button (click)="addClassificationMode()">
                            <mat-icon>add</mat-icon> Create New Product Classification
                        </button>
                    </mat-card-content>
                </mat-card>

                <mat-card *ngIf="selectedProductClassification" class="contrast">
                    <mat-card-content> 

                        <mat-form-field>
                            <mat-label>Name</mat-label>
                            <input type="text" matInput [(ngModel)]="selectedProductClassification.name" [disabled]="!updateProductClassificationMode && !addProductClassificationMode" required>
                        </mat-form-field>
                        
                        <div *ngIf="!updateProductClassificationMode && !addProductClassificationMode" fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="15px" class="p-t-10">
                            <button type="button" mat-stroked-button (click)="updateClassificationMode()">
                                <mat-icon>edit</mat-icon> Edit
                            </button>
                        </div>
                        
                        <div *ngIf="updateProductClassificationMode" fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="15px" class="p-t-10">
                            <button type="button" mat-stroked-button (click)="updateClassification()">
                                <mat-icon>save</mat-icon> Save
                            </button>
                            <button type="button" mat-stroked-button (click)="cancelAddOrUpdateClassificationMode()">
                                <mat-icon>cancel</mat-icon> Cancel
                            </button>
                        </div>
                        
                        <div *ngIf="addProductClassificationMode" fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="15px" class="p-t-10">
                            <button type="button" mat-stroked-button (click)="addClassification()">
                                <mat-icon>save</mat-icon> Save
                            </button>
                            <button type="button" mat-stroked-button (click)="cancelAddOrUpdateClassificationMode()">
                                <mat-icon>cancel</mat-icon> Cancel
                            </button>
                        </div>

                    </mat-card-content>
                </mat-card>
            </div>
        </mat-card-content>
    </mat-card>

    <mat-card>
        <mat-card-header>
            <mat-card-title>Product Types</mat-card-title>
        </mat-card-header>
        <mat-card-content>
            <div class="m-b-20">
                If you need to add a new replacement tag for a product type, go to <a routerLink="/products/replacement-tags">Product Replacement Tags</a>.
            </div>

            <mat-form-field>

                <input matInput type="text" placeholder="Select Product Type" [formControl]="typeControl" [matAutocomplete]="typeAuto">
                <button mat-button *ngIf="selectedProductType && !updateProductTypeMode && !addProductTypeMode" matSuffix mat-icon-button aria-label="Clear" (click)="clearTypeSelection()">
                    <mat-icon>close</mat-icon>
                </button>
                <mat-autocomplete #typeAuto="matAutocomplete" [displayWith]="displayTypeName" (optionSelected)="onTypeSelected($event.option.value)">
                    <mat-option *ngFor="let item of filteredTypes | async" [value]="item">
                        <span [innerHtml]="item.name | encodeHtml | highlight: typeControl.value"></span>
                    </mat-option>
                </mat-autocomplete>
            </mat-form-field>

            <mat-card *ngIf="!selectedProductType" class="contrast">
                <mat-card-content fxLayout="column" fxLayoutAlign="space-around center" fxLayoutGap="15px">
                    <div>Select a Product Type</div>
                    <div><b>OR</b></div>
                    <button type="button" mat-flat-button (click)="addTypeMode()">
                        <mat-icon>add</mat-icon> Create New Product Type
                    </button>
                </mat-card-content>
            </mat-card>


            <mat-card *ngIf="selectedProductType" class="contrast">
                <mat-card-content> 

                    <mat-form-field>
                        <mat-label>Name</mat-label>
                        <input type="text" matInput [(ngModel)]="selectedProductType.name" [disabled]="true" [disabled]="!updateProductTypeMode && !addProductTypeMode" required>
                    </mat-form-field>

                    <mat-form-field>
                        <mat-label>Template Name</mat-label>
                        <input type="text" matInput [(ngModel)]="selectedProductType.templateName" [disabled]="true" [disabled]="!updateProductTypeMode && !addProductTypeMode" required>
                    </mat-form-field>

                    <mat-form-field>
                        <mat-label>Product Classification</mat-label>
                        <mat-select [(ngModel)]="selectedProductType.productClassificationId" [disabled]="true" [disabled]="!updateProductTypeMode && !addProductTypeMode" required>
                            <mat-option *ngFor="let item of productClassifications" [value]="item.id">
                                {{ item.name }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>

                    <div *ngIf="!updateProductTypeMode && !addProductTypeMode" fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="15px" class="p-t-10">
                        <button type="button" mat-stroked-button (click)="updateTypeMode()">
                            <mat-icon>edit</mat-icon> Edit
                        </button>
                    </div>
                        
                    <div *ngIf="updateProductTypeMode" fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="15px" class="p-t-10">
                        <button type="button" mat-stroked-button (click)="updateType()">
                            <mat-icon>save</mat-icon> Save
                        </button>
                        <button type="button" mat-stroked-button (click)="cancelAddOrUpdateTypeMode()">
                            <mat-icon>cancel</mat-icon> Cancel
                        </button>
                    </div>
                    
                    <div *ngIf="addProductTypeMode" fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="15px" class="p-t-10">
                        <button type="button" mat-stroked-button (click)="addType()">
                            <mat-icon>save</mat-icon> Save
                        </button>
                        <button type="button" mat-stroked-button (click)="cancelAddOrUpdateTypeMode()">
                            <mat-icon>cancel</mat-icon> Cancel
                        </button>
                    </div>

                    <div *ngIf="!addProductTypeMode" class="m-t-10">
                        <accordion >
                            <mat-expansion-panel>
                                <mat-expansion-panel-header>
                                    <mat-panel-title>Related Theme Replacement Tags</mat-panel-title>
                                </mat-expansion-panel-header>
                                <button type="button" class="m-t-10" mat-stroked-button (click)="updateRelatedReplacementTags()">
                                    <mat-icon>save</mat-icon> Save
                                </button>
                                
                                <div fxLayout="row" fxLayoutAlign="space-between start" fxLayoutGap="15px" class="p-t-10">
                                    <div style="width: 100%;" fxLayout="column" fxLayoutAlign="start start">
                                        <h4>Not Related</h4>
                                        <div *ngFor="let item of filterNotRelatedReplacementTags()" class="not-related-replacement-tag" fxLayout="row" fxLayoutAlign="start center" (click)="addRelatedReplacementTag(item)">
                                            {{ item.tag }}
                                            <mat-icon>add</mat-icon>
                                        </div>
                                    </div>
                                    <div style="width: 100%;" fxLayout="column" fxLayoutAlign="start end">
                                        <h4>Related</h4>
                                        <div *ngFor="let item of filterRelatedReplacementTags()" class="related-replacement-tag" fxLayout="row" fxLayoutAlign="end center" (click)="removeRelatedReplacementTag(item)">
                                            <mat-icon>remove</mat-icon>
                                            {{ item.tag }}
                                        </div>
                                    </div>
                                </div>

                                <button type="button" class="m-t-10" mat-stroked-button (click)="updateRelatedReplacementTags()">
                                    <mat-icon>save</mat-icon> Save
                                </button>
                            </mat-expansion-panel>
                        </accordion>
                    </div>

                </mat-card-content>
            </mat-card>
        </mat-card-content>
    </mat-card>

    <mat-card>
        <mat-card-header>
            <mat-card-title>Product Specifications</mat-card-title>
        </mat-card-header>
        <mat-card-content>
            <mat-card *ngIf="!selectedProductTypeId" class="contrast">
                <mat-card-content fxLayout="column" fxLayoutAlign="space-around center" fxLayoutGap="15px">
                    <div>Select a Product Type to view and edit its specifications</div>
                </mat-card-content>
            </mat-card>

            <product-specification-edit
            [productSpecifications]="productSpecifications"
            [productTypeIdFilter]="selectedProductTypeId"
            (onSaveUpdate)="updateSpecification($event)"
            (onSaveAdd)="addSpecification($event)"
            (editingChange)="onSpecificationEditingChange($event)"
            ></product-specification-edit>
        </mat-card-content>
    </mat-card>
</div>